import type React from 'react';
import { PureComponent } from 'react';
import { connect, type MapStateToPropsParam, type MergeProps, type Options } from 'react-redux';
import Loading from '../components/loading/index.js';

export type ConnectedProps = {
  mapStateToProps: MapStateToPropsParam<any, any, any>;
  mapDispatchToProps: any;
  mergeProps?: MergeProps<any, any, any, Record<string, unknown>>;
  options?: Options<any, any, any, Record<string, unknown>>;
  onComponentWillMount?: (props: any) => void;
  onComponentWillUnmount?: (props: any) => void;
  onComponentWillReceiveProps?: (newProps: any, props: any) => void;
  loadingClassName?: string;
  loading?: boolean;
};

export type ConnectedComponentProps = {
  showComponent?: boolean;
  error?: string;
};

const Connected = <T,>(props: ConnectedProps) => {
  const {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
    options,
    onComponentWillMount,
    onComponentWillUnmount,
    onComponentWillReceiveProps,
    loadingClassName,
    loading = true
  } = props;
  // biome-ignore lint/style/noNonNullAssertion: react-redux connect() overload requires non-undefined mergeProps
  const connected = connect(mapStateToProps, mapDispatchToProps, mergeProps!, options);

  return (DecoratedComponent: React.ComponentType<T & ConnectedComponentProps>) => {
    // TODO: https://app.shortcut.com/takeshape/story/6982/rewrite-connecteddecorator-to-remove-deprecated-method-unsafe-componentwillreceiveprops
    class ConnectedDecorator extends PureComponent<T & ConnectedComponentProps> {
      override componentDidMount() {
        if (onComponentWillMount) {
          onComponentWillMount(this.props);
        }
      }

      override componentWillUnmount() {
        if (onComponentWillUnmount) {
          onComponentWillUnmount(this.props);
        }
      }

      override UNSAFE_componentWillReceiveProps(newProps: Readonly<T & ConnectedComponentProps>) {
        if (onComponentWillReceiveProps) {
          onComponentWillReceiveProps(newProps, this.props);
        }
      }

      override render() {
        if (Boolean(this.props.showComponent) || this.props.showComponent === undefined) {
          return <DecoratedComponent {...this.props} />;
        }

        return loading ? <Loading className={loadingClassName} /> : null;
      }
    }

    return connected<any>(ConnectedDecorator);
  };
};

export default Connected;
